import React, { useEffect } from 'react';

import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { isEmpty } from 'lodash';

import queryString from 'query-string';

import BobPage from '../../../components/BobPage';
import BobLoadingMask from '../../../components/BobLoadingMask';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import SensorForm from './SensorForm';

import * as BobActions from '../../../actions/bobActions';
import * as DashboardActions from '../../../actions/dashboardActions';

import classes from './SensorPage.module.css';

const SensorPage = ({
    activeNavCompany,
    activeNavSite,
    allSensors,
    allSensorsMeta,
    bobLoading,
    fetchEntitySensors,
    fetchSensorCalculations,
    history,
    location,
    sensorCalculations,
    ...props
}) => {

    const queryValues = queryString.parse(history.location.search);

    const sensorHistory = history.location.state;

    useEffect(() => {
        const init = async () => {
            let promises = [];

            if (queryValues.system) {
                if (isEmpty(allSensorsMeta)) {
                    promises.push(fetchEntitySensors(queryValues.site, queryValues.system));
                }
                promises.push(fetchSensorCalculations({ systemId: queryValues.system }));
            } else {
                if (isEmpty(allSensorsMeta)) {
                    promises.push(fetchEntitySensors(queryValues.site, queryValues.equipment));
                }
                promises.push(fetchSensorCalculations({ equipmentId: queryValues.equipment }));
            }
            Promise.all(promises.map(p => p.catch(err => err)));
        };

        if (activeNavCompany.id) init();
    }, [activeNavCompany]);

    useEffect(() => {
        const init = async () => {
            let parentId = queryValues.equipment;
            if (!parentId) {
                parentId = queryValues.system;
            }
            await fetchEntitySensors(activeNavSite.id, parentId);
        };

        if (activeNavCompany.id && activeNavSite.id && isEmpty(allSensorsMeta)) init();
    }, [activeNavCompany, activeNavSite, queryValues.equipment, queryValues.system, allSensorsMeta]);

    return (
        <BobPage>
            <div className={classes.SensorPage}>
                <div className={classes.BreadcrumbPanel}>
                    <Breadcrumb />
                </div>
                <div className={classes.HeaderPanel}>
                    Sensor
                </div>
                <div className={classes.FormPanel}>
                    <SensorForm
                        sensors={allSensors}
                        sensorHistory={sensorHistory}
                        sensorCalculations={sensorCalculations}
                    />
                </div>
            </div>
            {
                bobLoading.includes('SensorCalculations') || isEmpty(activeNavSite) || isEmpty(allSensorsMeta) ?
                    <BobLoadingMask />
                    :
                    null
            }
        </BobPage>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany:   state.bob.activeNavCompany,
        activeNavSite:      state.bob.activeNavSite,
        allSensors:         state.bob.allSensors,
        allSensorsMeta:     state.bob.allSensorsMeta,
        bobLoading:         state.bob.bobLoading,
        sensorCalculations: state.dashboard.sensorCalculations
    };
};

const mapDispatchToProps = {
    ...BobActions,
    ...DashboardActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SensorPage));
